export const parcelleStyle = function myStyle(feature, layerName, zoom) {
  if (layerName == 'parcelles') {
    return {
      color: 'red',
      fillColor: 'green',
      opacity: 0.9,
      fillOpacity: 0,
      weight: 2
    };
  }
};

export const parcelleSelectedStyle = function myStyle(feature, layerName, zoom) {
  if (layerName == 'parcelles') {
    return {
      color: 'red',
      fillColor: 'green',
      opacity: 0.9,
      fillOpacity: 0.6,
      weight: 2
    };
  }
};

export const parcelleHoverStyle = function myStyle(feature, layerName, zoom) {
  if (layerName == 'parcelles') {
    return {
      color: 'red',
      fillColor: 'orange',
      opacity: 0.9,
      fillOpacity: 0.5,
      weight: 2
    };
  }
}

export const parcelleSelectedHoverStyle = function myStyle(feature, layerName, zoom) {
  if (layerName == 'parcelles') {
    return {
      color: 'red',
      fillColor: 'orange',
      opacity: 0.9,
      fillOpacity: 0.5,
      weight: 2
    };
  }
}
